"use client";

import dynamic from "next/dynamic";
import { useAfterPaint } from "@/lib/motion/useAfterPaint";

const RevealMotion = dynamic(() => import("./RevealMotion"), { ssr: false });

/** Mount once per page that uses ScrollReveal. Loads GSAP after first paint. */
export default function SectionReveals() {
  return useAfterPaint(2) ? <RevealMotion /> : null;
}
